import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './layout/Layout';
import Login from './components/Login';

// Main App Component with Auth Logic
function AppContent() {
     const { isAuthenticated, loading } = useAuth();

     // Show loading spinner while checking authentication
     if (loading) {
          return (
               <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                    <div className="text-center">
                         <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                              <span className="sr-only">Loading...</span>
                         </div>
                         <p className="text-muted">Loading application...</p>
                    </div>
               </div>
          );
     }

     // Show login page if not authenticated
     if (!isAuthenticated()) {
          return (
               <Routes>
                    <Route path="*" element={<Login />} />
               </Routes>
          );
     }

     // Show main application if authenticated
     return (
          <Routes>
               <Route path="/*" element={<Layout />} />
               <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
     );
}

// Root App Component with Auth Provider
function App() {
     return (
          <AuthProvider>
               <Router>
                    <AppContent />
               </Router>
          </AuthProvider>
     );
}

export default App;
